var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingIssue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.864,
    height: 15.444,
    viewBox: "0 0 12.864 15.444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-42.773)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.582)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fd7c7c",
    d: "M144.59,1.053,142.761,0l-1.828,1.053L139.1,0l-1.828,1.053-1.371-.79V12.676h8.16V14.5a.947.947,0,1,0,1.895,0V.264Zm-7.57,7.214V7.352h3.914v.915Zm7.827-2H137.02V5.355h7.827Zm0-2H137.02V3.358h7.827Z",
    transform: "translate(-135.906)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.773 13.59)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fd7c7c",
    d: "M52.827,451.45v-.906H42.773v.906a.948.948,0,0,0,.947.947h9.366A1.851,1.851,0,0,1,52.827,451.45Z",
    transform: "translate(-42.773 -450.544)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingIssue);
export default __webpack_public_path__ + "static/media/billing-Issue.6057b0f6.svg";
export { ForwardRef as ReactComponent };